import { TranslationLoadedService } from '../translate/translation-loaded.service';
import { TranslateLoader } from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from '../translate/MultiTranslateHTTPLoader';

export default function TranslationLoaderFactory(translationLoaded: TranslationLoadedService): TranslateLoader {
    return new MultiTranslateHttpLoader(translationLoaded);
}
